function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCombSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 511.996 511.996",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#656D78"
    },
    d: "M507.04,124.563l-78.233-78.28c-6.249-6.25-14.437-9.358-22.624-9.358s-16.359,3.108-22.609,9.358 L9.369,420.48c-12.492,12.499-12.492,32.749,0,45.233c6.242,6.25,14.429,9.359,22.617,9.359c8.18,0,16.367-3.109,22.609-9.359 l185.747-185.747l55.625,55.671c8.547,3.516,15.733,4.953,21.78,4.953c26.499,0,30.983-27.577,30.983-27.577l-70.701-70.733 l135.686-135.686l70.701,70.733C484.415,177.328,526.009,170.562,507.04,124.563z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M466.493,189.5L466.493,189.5l-71.873-71.874l-15.078,15.078l71.874,71.874l0,0 c4.155,4.172,10.905,4.172,15.077,0C470.649,200.422,470.649,193.672,466.493,189.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M436.338,219.655l-71.874-71.873l-15.078,15.077l71.859,71.858l0.016,0.016 c4.171,4.156,10.905,4.156,15.077,0C440.494,230.577,440.494,223.827,436.338,219.655L436.338,219.655z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M334.309,177.937l-15.078,15.078l71.874,71.874c4.172,4.156,10.922,4.156,15.078,0 c4.172-4.172,4.172-10.922,0-15.078L334.309,177.937z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M376.026,279.967L376.026,279.967l-71.873-71.873l-15.062,15.077l71.857,71.858c0,0,0,0,0.016,0.016 c4.156,4.156,10.906,4.156,15.062,0C380.198,290.873,380.198,284.123,376.026,279.967L376.026,279.967z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCombSvgrepoCom);
export default __webpack_public_path__ + "static/media/comb-svgrepo-com.378071443800d1ab520c405ac24768bb.svg";
export { ForwardRef as ReactComponent };